<div class="containerMain">
    <div class="cadre-nav">
        <app-nav></app-nav>
    </div>
    <app-slides></app-slides>
    <div class="cadre-devis"><app-devis></app-devis></div>
    <div class="cadre-spe"><app-specialistes></app-specialistes></div>
    <div class="cadre-services"><app-services></app-services></div>
    <div class="cadre-maison"><app-maison></app-maison></div>
    <div class="cadre-arguments"><app-arguments></app-arguments></div>
    <div class="cadre-footer"><app-footer></app-footer></div>
    <div class="cadre-footer2"><app-footer2></app-footer2></div>
</div>
